import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class PiratesHideout6PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.PIRATES_HIDEOUT6;
}

export default PiratesHideout6PoiTileEntity;
